module.exports = __webpack_public_path__ + "img/part-6-title.d4ce2ed4.png";